import React, { Component } from 'react';
import { connect } from 'react-redux';
import ResizeObserver from 'resize-observer-polyfill';
import { Responsive, WidthProvider } from 'react-grid-layout';
import Modal from 'sub_components/Common/PortalModalNew';
import { PopUp } from 'styled_components/Common/PopUp';
import { BloxButton } from 'styled_components/Common/BloxButton';
import { RESOLUTIONS } from 'services/config';

/** v3 imports */
import LoginInput from 'sub_components/Login/LoginInput';
import ForgotPassword from 'sub_components/Login/ForgotPassword';
import HelpModal from 'sub_components/Common/HelpModal';
const CDN_URL = process.env.REACT_APP_CDN_URL;
const edge = `${CDN_URL}common/edge.png`;
const chrome = `${CDN_URL}common/chrome.png`;
const safari = `${CDN_URL}common/safari.png`;
const firefox = `${CDN_URL}common/firefox.png`;

const ResponsiveReactGridLayout = WidthProvider(Responsive);
/**
 * Container component for LoginInput and Canvas Components
 * Handles login progress once authenticated
 */

function getModalTitle(browserName) {
	return browserName === 'Unsupported browser detection'
		? 'Your browser is important.....'
		: 'Browsers are like old cars....';
}

function getModalText(browserName) {
	return browserName === 'Unsupported browser detection'
		? 'custom'
		: 'every few years you need to upgrade. This site may not work with your browser.';
}

function checkCorrectOperaVersion(version) {
	let correctVersion = false;
	if (parseInt(version) > 80) {
		correctVersion = true;
	}
	return correctVersion;
}

function browserDetect(setShowModal, setModalTitle, setModalText) {
	const userAgent = navigator.userAgent;
	let browserName = 'Unsupported browser detection';
	let version;
	let correctVersion = false;

	if (userAgent.match(/opr\//i)) {
		browserName = 'opera';
		version = userAgent.split('OPR/')[1];
		version = version.substring(0, 3);

		correctVersion = checkCorrectOperaVersion(version);
	} else if (userAgent.match(/edg/i)) {
		browserName = 'edge';
		version = userAgent.split('Edg/')[1];
		version = version.substring(0, 3);
		if (parseInt(version) > 90) {
			correctVersion = true;
		}
	} else if (userAgent.match(/chrome|chromium|crios/i)) {
		browserName = 'chrome';
		version = userAgent.split('Chrome/')[1];
		version = version.substring(0, 3);
		if (parseInt(version) > 90) {
			correctVersion = true;
		}
	} else if (userAgent.match(/firefox|fxios/i)) {
		browserName = 'firefox';
		version = userAgent.split('Firefox/')[1];
		version = version.substring(0, 3);

		if (parseInt(version) > 90) {
			correctVersion = true;
		}
	} else if (userAgent.match(/safari/i)) {
		browserName = 'safari';
		version = userAgent.split('Version/')[1];
		version = version.substring(0, 3);
		if (parseInt(version) > 14) {
			correctVersion = true;
		}
	}
	const modalTitle = getModalTitle(browserName);

	const modalText = getModalText(browserName);

	if (!correctVersion) {
		setModalTitle(modalTitle);
		setModalText(modalText);
		setShowModal(true);
	}
}

class LoginPage extends Component {
	constructor(props) {
		super(props);

		this.timer = null;
		this.state = {
			rowHeight: 0,
			margin: [],
			containerPadding: [],
			layout: [],
			showModal: false,
			showHelpModal: false,
			modalTitle: '',
			modalText: '',
			showBrowserModal: false,
			breakpoint: RESOLUTIONS.MED,
		};
	}

	getCustomBody = () => {
		const { modalText } = this.state;
		let newText = '';
		if (modalText === 'custom') {
			newText =
				"<div className='text body10'>" +
				'you can use it to download ' +
				'<img src=' +
				chrome +
				' /> ,' +
				'<img src=' +
				firefox +
				' /> ,' +
				'<img src=' +
				safari +
				' />, <img src=' +
				edge +
				' />.This site may not work with your browser.</div>';
		}
		return newText;
	};

	/**
	 * Checks to see if the user is authenticated. If so, move to
	 * the next page (HomePage). Waits for 2 seconds before re-routing
	 * to allow animation to finish.
	 */
	checkCompletion = () => {
		const { auth_status, navigateToPortal } = this.props;
		if (
			auth_status.type === 'LOGIN_SUCCESS_PHASE_ONE_NO_MFA' ||
			(auth_status.context === 'AUTHENTICATED' && auth_status.isAuthenticated)
		) {
			this.timer = setTimeout(() => {
				navigateToPortal();
			}, 500);
		}
	};

	componentWillUnmount() {
		clearTimeout(this.timer);
	}
	onBreakpointChange = breakpoint => {
		let rowHeight = 0;
		let margin;
		let containerPadding;

		switch (breakpoint) {
			case 'xs':
				rowHeight = 15;
				margin = [21, 0];
				containerPadding = [90, 0];
				break;
			case 'sm':
				rowHeight = 18;
				margin = [21, 0];
				containerPadding = [95, 0];
				break;
			case 'md':
				rowHeight = 21;
				margin = [22, 0];
				containerPadding = [120, 0];
				break;
			case 'lg':
				rowHeight = 24;
				margin = [32, 0];
				containerPadding = [160, 0];
				break;
			default:
				rowHeight = 23;
				margin = [22, 0];
				containerPadding = [30, 0];
				break;
		}

		this.setState({ rowHeight, margin, containerPadding });
	};
	setShowModal = () => {
		const { showBrowserModal } = this.state;
		this.setState({ showBrowserModal: !showBrowserModal });
	};
	setModalText = text => {
		this.setState({ modalText: text });
	};
	setModalTitle = title => {
		this.setState({ modalTitle: title });
	};
	componentDidMount() {
		this.onBreakpointChange();
		browserDetect(this.setShowModal, this.setModalTitle, this.setModalText);

		this.screenObserver = new ResizeObserver(entries => {
			entries.forEach(entry => {
				const screenWidth = entry.contentRect.width;
				const screenHeight = entry.contentRect.height;
				this.updateScreenBreakpoint(screenWidth, screenHeight);
			});
		});
		const htmlEl = document.querySelector('html');
		this.screenObserver.observe(htmlEl);
	}
	showModal = () => {
		const { showModal } = this.state;
		this.setState({ showModal: !showModal });
	};

	showHelpModal = () => {
		const { showHelpModal } = this.state;
		this.setState({ showHelpModal: !showHelpModal });
	};

	updateScreenBreakpoint = (screenWidth, screenHeight) => {
		let breakpoint = RESOLUTIONS.MED;

		if (screenWidth > RESOLUTIONS.LOW && screenWidth <= RESOLUTIONS.MED) {
			breakpoint = RESOLUTIONS.LOW;
		} else if (screenWidth > RESOLUTIONS.MED && screenWidth <= RESOLUTIONS.HIGH) {
			breakpoint = RESOLUTIONS.MED;
		} else if (screenWidth > RESOLUTIONS.HIGH) {
			breakpoint = RESOLUTIONS.HIGH;
		} else {
			breakpoint = RESOLUTIONS.MIN;
		}
		this.setState({ breakpoint, screenWidth, screenHeight });
	};

	render() {
		const {
			containerPadding,
			margin,
			rowHeight,
			showModal,
			showHelpModal,
			showBrowserModal,
			modalTitle,
			modalText,
			breakpoint,
		} = this.state;

		const { dispatch, auth_status } = this.props;
		const layoutSmall = [
			{ i: 'login-input', x: 0, y: 5, w: 6, h: 7, static: true },
			{ i: 'login-image', x: 0, y: 0, w: 12, h: 65, static: true },
			{ i: 'forgot-password', x: 0, y: 13, w: 12, h: 40, static: true },
		];
		const layoutMed = [
			{ i: 'login-input', x: 0, y: 5, w: 6, h: 7, static: true },
			{ i: 'login-image', x: 0, y: 0, w: 12, h: 65, static: true },
			{ i: 'forgot-password', x: 0, y: 13, w: 12, h: 40, static: true },
		];
		const layoutLarge = [
			{ i: 'login-input', x: 0, y: 5, w: 6, h: 7, static: true },
			{ i: 'login-image', x: 0, y: 0, w: 12, h: 50, static: true },
			{ i: 'forgot-password', x: 0, y: 13, w: 12, h: 40, static: true },
		];

		return (
			<>
				<ResponsiveReactGridLayout
					layouts={{ lg: layoutLarge, md: layoutMed, sm: layoutSmall, xs: layoutSmall }}
					//	layout={layoutSmall}
					measureBeforeMount={false}
					className={'login'}
					rowHeight={rowHeight}
					isDraggable={false}
					isResizable={false}
					breakpoints={{ lg: 2559, md: 2000, sm: 1440, xs: 900 }}
					cols={{ lg: 12, md: 12, sm: 12, xs: 6 }}
					containerPadding={containerPadding}
					onBreakpointChange={this.onBreakpointChange}
					margin={margin}
					//onLayoutChange={this.onLayoutChange}
				>
					<div key='login-input' className='login-form grid-item-rh'>
						<LoginInput checkCompletionCallback={this.checkCompletion} dispatch={dispatch} />
					</div>
					<div key='forgot-password' className='forgot-password  grid-item-ga'>
						{auth_status.status !== 'LOGIN_SUCCESS' && auth_status.status !== 'MFA_ERROR' && (
							<>
								<div
									data-cy='forgot-your-password'
									className='forgot-password-link'
									onClick={this.showModal}
								>
									Forgot your Password ?
								</div>
								{auth_status?.attemptCount >= 3 && (
									<div
										data-cy='trouble-logging-in'
										className='trouble-logging-in'
										onClick={this.showHelpModal}
									>
										Trouble Logging in ?
									</div>
								)}
							</>
						)}
					</div>
				</ResponsiveReactGridLayout>
				<div data-cy='forgot-password-modal' className='forgot-password-modal'>
					<ForgotPassword isOpen={showModal} toggleOpen={this.showModal} breakpoint={breakpoint} />
				</div>
				<div data-cy='help-modal' className='help-modal'>
					<HelpModal
						isOpen={showHelpModal}
						toggleOpen={this.showHelpModal}
						breakpoint={breakpoint}
					/>
				</div>
				{showBrowserModal && (
					<Modal>
						<PopUp
							showModal={showBrowserModal}
							customBody={this.getCustomBody()}
							closeModal={() => this.setShowModal(false)}
							footer={
								<BloxButton
									className='buttons41'
									id='okay'
									text='OKAY'
									module='support'
									enabled={true}
									onClick={() => this.setShowModal(false)}
									cypressId='okay'
								/>
							}
							title={modalTitle}
							text={modalText}
							module='support'
						/>
					</Modal>
				)}
			</>
		);
	}
}

function mapStateToProps(state) {
	return {
		auth_status: state.auth_status,
	};
}

export default connect(mapStateToProps, null)(LoginPage);
